import './pa_section_style.scss';

export const PracticeAreasSection = ({
    fields
}) => {
    
    return <section id="pa-section" className="home-section">
        <div className="container">
            <div className='section-header'>
                <span className='main-category'>Practice Areas</span>
                <h2>
                    <span className='title-first'>{ fields?.pa_title}</span>
                    <span className='title-second'>{ fields?.pa_title_2}</span>
                </h2>
            </div>

            <div className="pa-wrapper">
                <div className='decoration'></div>
                <div className="section-left-content">
                    <div className="hero-img"></div>
                    <div className="description">
                        <p dangerouslySetInnerHTML={{__html: fields?.banner_description}}></p>
                    </div>
                </div>
                <div className="section-right-content">
                    {
                        fields?.pa_repeater && <ul>
                            {
                                fields?.pa_repeater?.map((it, index) => <li key={index}>
                                    <div className="service-name"><a href={it?.block_link}>{it?.block_title}</a></div>
                                    <div className="expand-icon">
                                        <a href="{it?.block_link}">
                                            <svg width="23" height="20" viewBox="0 0 23 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M13.2222 2L21 10M21 10L13.2222 18M21 10H1" stroke="#0E5116" strokeWidth="2" strokeLinecap="square"/>
                                            </svg>
                                        </a>
                                    </div>
                                </li>)
                            }                        
                        </ul>
                    }
                </div>
            </div>
        </div>
    </section>
}